module.exports = __webpack_public_path__ + "img/icon_firstServe.9a06039e.png";